<template>
  <div>
    <div class="type-filter">
      <span class="filter-title pc">
        <span class="text">{{ name }}</span>
      </span>
      <div class="type-list pc">
        <span
          class="type-item"
          :class="{'selected': selectedType === 0 }"
          v-if="hasWholeType"
          @click="handleSelect(0)"
        >{{ wholeTypeName }}</span>
        <span
          class="type-item"
          :class="{'selected': selectedType === item.id }"
          v-for="(item, index) in types"
          :key="index"
          @click="handleSelect(item)"
        >{{ item.name }}</span>
      </div>
    </div>
    <el-select
      class="mobile"
      popper-class="type-filter-select"
      v-model="selectedType"
      @change="handleSelectChange"
      :placeholder="name"
    >
      <el-option v-if="hasWholeType" :label="name" :value="0"></el-option>
      <el-option v-for="(item, index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "typeFilter",
  props: {
    name: {
      type: String,
      required: true
    },
    valName: {
      type: String,
      required: false
    },
    hasWholeType: {
      type: Boolean,
      default: true
    },
    wholeTypeName: {
      type: String,
      required: true
    },
    types: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    },
    defaultType: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      selectedType: this.defaultType
    };
  },
  watch: {
    defaultType: function() {
      this.selectedType = this.defaultType;
    }
  },
  methods: {
    handleSelect(item) {
      if (item === 0) {
        this.selectedType = 0;
      } else {
        this.selectedType = item.id;
      }

      this.$emit("type-change", this.selectedType, this.valName);
    },
    handleSelectChange(val) {
      this.$emit("type-change", val, this.valName);
    }
  }
};
</script>

<style scoped>
.type-filter {
  display: flex;
}

.filter-title {
  font-size: 16px;
  color: #888;
  width: 70px;
}

.type-list {
  flex: 1;
  margin-left: 6px;
}

.type-item {
  font-size: 16px;
  color: #666;
  padding: 10px 10px;
  cursor: pointer;
  margin-left: 10px;
}

.type-item.selected {
  display: inline-block;
  padding: 3px 10px;
  color: #7691FF;
  background: #E9ECFC;
  border-radius: 15px;
}

@media (max-width: 767px) {
}
</style>

<style lang="scss">
.type-filter-select {
  .el-select-dropdown__item.selected {
    color: #7691FF !important;
  }
}
</style>
